import { Checkbox, Popup } from "semantic-ui-react";
import { ConfirmBoxOptionsType } from "../../reducer/type";
import { Dispatch, SetStateAction } from "react";

type RemoveFIPProps = {
  options: ConfirmBoxOptionsType;
  setOptions: Dispatch<SetStateAction<ConfirmBoxOptionsType>>;
};

const RemoveFIP = ({ options, setOptions }: RemoveFIPProps) => {
  const onChange = () => {
    setOptions((prevOptions) => ({
      ...prevOptions,
      removeFIP: !prevOptions.removeFIP,
    }));
  };

  return (
    <Popup
      trigger={
        <Checkbox
          className="simple-checkbox margin-top-half color-gray"
          label="Release Floating IPs"
          checked={options.removeFIP}
          onChange={onChange}
        />
      }
    >
      <div>
        Using this feature will automatically release (remove) floating ips upon
        successful server removal.
      </div>
    </Popup>
  );
};

export default RemoveFIP;
